import { useTranslation } from 'react-i18next'

import { TransactionsAlertIcon } from '@reveni-io/reveni-ui'

import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

import * as Styles from './styles'

const TransactionAlertCard = ({ alertsCount, onClick }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Statistic
        size="small"
        status={statisticStatuses.warning}
        isAlert
        Icon={TransactionsAlertIcon}
        label={t('Alertas de transacciones')}
        value={alertsCount}
        showStatusIcon
        onClick={onClick}
        orientation="horizontal"
      />
    </Styles.Container>
  )
}

export default TransactionAlertCard
